import React, { Component } from 'react';
import {connect} from 'react-redux';
import __ from 'lodash';
import history from '../../../../history';
import { CONFIG,URL_AKM } from '../../../../config';
import accountManagement from '../../../../apis/accountManagement';
import akmApi from '../../../../apis/akmApi';
import {cekCookies} from '../../../../actions';
import Loader from '../../../Loader';
import LoaderModal from '../../../modal/LoaderModal';
import PaginationData from '../../../../entity/PaginationData';
import PaginationTable from '../masterDropDown/PaginationTable';
import Navbar from '../../navbar/Navbar';
import Sidebar from '../../sidebar/Sidebar';
import {Alert} from 'react-bootstrap';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Paper,IconButton,Typography,Collapse,Box, Button, ButtonGroup} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import GetAppIcon from '@material-ui/icons/GetApp';

class AkmList extends Component {
    constructor(props) {
        super(props);
        this.state = { 
            isFetching: false,
            isSearch: false,            
            isHapusProfil: false,  
            isHapusMapel: false, 
            alertShow: false,
            resMessage: 'Error',
            listProfil: [],
            listMapel: [],
            nonAkademik: [],
            tipeCbt: 'AN',
            paginationData: PaginationData,
            hapusData: {}
        }
    }
    async componentDidMount() { 
        const uri = window.location.href;
        if(uri.includes('qs')) {
            this.setState({ tipeCbt: 'QUEST'});
        }
        await this.props.cekCookies();    
        if(!__.isEmpty(this.props.account)) {
            this.fetchProfil();
            
        }         
        
    }
    fetchProfil = async() => {   
        this.setState({isSearch:true, listProfil: []})     
        const result = await akmApi.get(URL_AKM.AKM_LIST, {
            params: { page: this.state.paginationData.page, 
                    size: this.state.paginationData.size, 
                    tipeCbt: this.state.tipeCbt }
        })
        if(result){
            if(result.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                let dataList = result.data.data.content.map((item) => { return {...item, open: false} }); 
                this.setState({
                    listProfil: dataList,
                    paginationData: {...this.state.paginationData, 
                        page: result.data.data.number,
                        size: result.data.data.size,
                        totalPages: result.data.data.totalPages,
                        numberOfElements: result.data.data.numberOfElements,
                        totalElements: result.data.data.totalElements
                    }
                })
                if(this.props.location.state !== undefined) {
                    let profil = this.props.location.state.profil;                    
                    this.setOpen({...profil, open: false});
                }                
            } else {
                this.setState({
                    alertShow: true,
                    resMessage: result.data.errorSchema.errorMessage    
                })
            }            
            this.setState({isSearch:false})
        }        
    } 

    fetchNonAkademik = async(idProfilCbt) => {
        this.setState({isFetching: true})
        const response = await akmApi.get(URL_AKM.GET_PROFIL_NON_AKADEMIK_AKM + idProfilCbt).catch (function(error){ alert(error) })            

        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({
                    nonAkademik: response.data.data
                })    
            } else {
                this.setState({ nonAkademik: [] })
            }  
            this.setState({isFetching: false})          
        }   
    }

    loadAlert = () => {
        const {alertShow } = this.state;      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{this.state.resMessage}</strong>
            </Alert>
          );
        } 
    } 

    setOpen = async(profil) => {
        this.setState(state => ({
            ...state,
            listProfil: this.state.listProfil.map(item =>
              item.idProfilCbt === profil.idProfilCbt ? { ...item, open: !profil.open } : { ...item, open: false }
            )
        }));
        if(!profil.open) {
            this.setState({ isFetching: true, listMapel: [] })           

            const response = await akmApi.get(URL_AKM.GET_SUBPROFIL_BY_IDPROFIL + profil.idProfilCbt).catch (function(error){ alert(error) })            

            if(response){
                if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                    this.setState({
                        listMapel: response.data.data
                    })                        
                }   
                this.setState({isFetching: false});            
            }
            if(this.state.tipeCbt === 'AN')  
                this.fetchNonAkademik(profil.idProfilCbt);      
        }  
    }
    
    renderRow() { 
        return (
                <>
                {this.state.listProfil.map((profil,i) => 
                <React.Fragment key={i}>
                <TableRow >
                    <TableCell>
                    <IconButton aria-label="expand row" size="small" onClick={() => this.setOpen(profil)}>
                        {profil.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    </TableCell>
                    <TableCell align="left">{profil.namaProfil}</TableCell>
                    <TableCell align="left">{profil.namaKurikulum}</TableCell>
                    <TableCell align="left">{profil.namaKelas}</TableCell>                    
                    <TableCell align="right">
                        <div className="button-group">
                            <button className="btn btn-outline-dark btn-sm" onClick={() => this.handleProfil(profil)}><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>&nbsp;
                            <button className="btn btn-outline-dark btn-sm" onClick={() => this.handleProfilDialog(profil)}><i className="fa fa-trash-o" aria-hidden="true"></i></button>								
                        </div>
                    </TableCell>
                </TableRow> 
                
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                    <Collapse in={profil.open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                        <Typography variant="h6" gutterBottom component="div">
                            <button className="btn btn-outline-primary btn-sm" onClick={() => this.handleSubProfil(profil,{})}>
                                <i className="fa fa-plus" aria-hidden="true"></i> tambah Details
                            </button> 
                        </Typography>
                        
                        <Table size="small" aria-label="mapel">
                            <TableHead>
                            <TableRow>
                                <TableCell>Mata Pelajaran</TableCell>
                                <TableCell>Soal</TableCell>
                                <TableCell align="right">Durasi</TableCell>
                                <TableCell align="right">KKM</TableCell>
                                <TableCell align="center">Random</TableCell>
                                <TableCell></TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                            {this.state.listMapel.map((mapel,idx) => 
                                <TableRow key={idx}>
                                <TableCell component="th" scope="row">
                                    {mapel.namaKategoriSubProfil == null ? mapel.namaMapel : mapel.namaMapel + '(' + mapel.namaKategoriSubProfil + ')'}
                                </TableCell>
                                <TableCell>{mapel.jumlahSoal}
                                    <IconButton color="primary" size="small" title="preview soal..." component="span" onClick={() => this.handlePreviewSoal(profil, mapel)}>
                                        <VisibilityRoundedIcon fontSize="small" />
                                    </IconButton>
                                    <IconButton style={{color: '#dc3545'}} size="small" title="download soal..." component="span" onClick={() => this.handleDownloadSoal(profil, mapel)}>
                                        <GetAppIcon fontSize="small" />
                                    </IconButton>
                                </TableCell>                                
                                <TableCell align="right">{mapel.durasi} menit</TableCell>
                                <TableCell align="right">{mapel.ketuntasanMinimum}</TableCell>
                                <TableCell align="center">{mapel.random === 1 ? 
                                    <i className="fa fa-check text-success" aria-hidden="true"></i> :
                                    <i className="fa fa-remove text-danger" aria-hidden="true"></i>}
                                </TableCell>
                                <TableCell align="right">
                                    <ButtonGroup variant="text" size="small" aria-label="text primary button group">
                                        <Button style={{color: '#00a426'}} onClick={() => this.handleAddSoal(profil,mapel)}>add soal</Button>
                                        <Button style={{color: '#ffc107'}} onClick={() => this.handleSubProfil(profil,mapel)}>edit</Button>
                                        <Button style={{color: '#dc3545'}} onClick={() => this.handleSubProfilDialog(mapel)}>hapus</Button>
                                    </ButtonGroup>
                                </TableCell>
                                </TableRow>
                            )}

                            
                            {this.state.nonAkademik.length > 0 && <>   
                            {this.state.nonAkademik.map((item,i) => 
                            <TableRow key={i}>
                                <TableCell align="center" colSpan={5}>{item.namaProfilAgcu}</TableCell>
                                    <TableCell align="center">
                                    
                                    <Checkbox
                                        checked={item.idProfilCbt !== null}
                                        onChange={() => this.handleChangeNonAkademik(item, profil.idProfilCbt)}                                        
                                        color="primary"
                                        inputProps={{ 'aria-label': 'secondary checkbox' }}
                                    />
                                </TableCell>
                            </TableRow>
                            )}
                            </>}
                           

                            
                            </TableBody>
                        </Table>
                        </Box>
                    </Collapse>
                    </TableCell>
                </TableRow>
                </React.Fragment>
                )}
            </>
        );
    }

    loading = () =>{
        if(this.state.isSearch){
            return(
                <Loader />
            )
        }
    }

    handleChangeNonAkademik = async(data, idProfilCbt) => {
        this.setState({isFetching: true}); 
        const response = await akmApi.post(URL_AKM.POST_PROFIL_NON_AKADEMIK_AKM, {...data, idProfilCbt: idProfilCbt}).catch (function(error){ alert(error) })  
        if(response){
            if(response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                let nonAkademik = [...this.state.nonAkademik];
                nonAkademik.map(item => {
                    if(item.idProfilAgcuNonAkademik === data.idProfilAgcuNonAkademik) {
                        item.idProfilCbt = response.data.data.idProfilCbt;
                        item.idProfilCbtAgcuHub = response.data.data.idProfilCbtAgcuHub;
                    }
                })

                this.setState({nonAkademik: nonAkademik})                    
            } else {
                this.setState({
                    alertShow: true, resMessage: response.data.errorSchema.errorMessage
                })
            }            
        }
    
        this.setState({isFetching: false});   
    }
    
    handleChangePage = async(newPage) => {
        this.state.paginationData.page = newPage;
        this.fetchProfil();
    }

    handleChangeRowsPerPage = (size) => {
        this.state.paginationData.page = 0;
        this.state.paginationData.size = size;
        this.fetchProfil();
    }

    handleProfil = (data) => {  
        history.push({
            pathname: '/cbt/post/' + this.state.tipeCbt,
            state: {profil: data, nonAkademik: this.state.nonAkademik} 
        })
    }
    handleSubProfil = (profil, subprofil) => {  
        history.push({
            pathname: '/cbt/mapel/',
            state: {profil: profil, subProfil: subprofil} 
        })
    } 
    handleNonAkademik = (profil) => {  
        history.push({
            pathname: '/akm_nonakademik',
            state: {profil: profil, nonAkademik: this.state.nonAkademik}
        })
    } 
    handleAddSoal = (profil, mapel) => {
        history.push({
            pathname: '/cbt/addsoal',
            state: {profil: profil, subProfil: mapel} 
        })      
    }
    handlePreviewSoal = (profil,mapel) => {
        history.push({
            pathname: '/soal-preview',
            state: {profil: profil, subProfil: mapel} 
        })  
    }

    handleDownloadSoal = (profil,mapel) => {
        history.push({
            pathname: '/download-soal',
            state: {profil: profil, subProfil: mapel} 
        })  
    }

    render() {    
        let pageTitle = 'AKM';
        if(this.state.tipeCbt === 'QUEST') pageTitle = "QUESTIONER"; 
        return ( 
            <div className="wrapper">
                <LoaderModal isFetching={this.state.isFetching}/> 
                <Sidebar account={this.props.account}/>
                <div id="content" style={{paddingBottom: '50px'}}>
                    <Navbar title={'List Profil ' + pageTitle}/>                  
                    {this.loading()}
                    {this.loadAlert()}
                    <div style={{marginBottom: '10px'}}>
                        <button className="btn btn-outline-dark btn-sm" onClick= {() => this.handleProfil({})}>
                            <i className="fa fa-plus" aria-hidden="true"></i> tambah Profil
                        </button>  
                    </div>
                    {this.state.listProfil.length !== 0 &&
                    <div>
                    
                    
                        
                    <TableContainer component={Paper}>                    
                        <Table aria-label="collapsible table">
                            <TableHead>
                            <TableRow>
                                <TableCell />
                                <TableCell align="left">Judul</TableCell>
                                <TableCell align="left">Kurikulum</TableCell>
                                <TableCell align="left">Kelas Group</TableCell>
                                <TableCell align="right">#Aksi</TableCell>
                            </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.renderRow()}
                            </TableBody>
                        </Table>
                        <PaginationTable paging={this.state.paginationData} handleChangePage={this.handleChangePage} handleChangeRowsPerPage={this.handleChangeRowsPerPage} />
                    </TableContainer>
                    
                    
                    </div>
                    }
                </div>
                {this.confirmDialog()}
            </div>
        );
    }   

    handleProfilDialog = (data) => {        
        this.setState({isHapusProfil: true, isHapusMapel: false, hapusData: data})
    }
    handleSubProfilDialog = (data) => {        
        this.setState({isHapusProfil: false, isHapusMapel: true, hapusData: data})
    }
    delete = async(id) => {        
        this.setState({ isFetching: true })
        const { listProfil } = this.state;        
        const json = { 'id' : id}
        const resDelete = await accountManagement.post(CONFIG.EXAM_DELETE, json)
            .catch(function(error){
                alert(error);
            });
        
        if (resDelete) {
            if(resDelete.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ 
                    isHapusProfil: false,
                    alertShow:true,
                    resMessage: resDelete.data.errorSchema.errorMessage,
                    listProfil: listProfil.filter(profil => profil.idProfilCbt !== id)
                });
            }
        }      
        this.setState({isFetching: false })
    }
    deleteSub = async(id) => {        
        this.setState({ isFetching: true })
        const json = { 'id' : id}
        const resDelete = await accountManagement.post(CONFIG.EXAM_DELETE_MAPEL, json)
            .catch(function(error){this.setState({alertShow:true,resMessage: error})});
        
        if (resDelete) {
            if(resDelete.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE){
                this.setState({ 
                    isHapusMapel: false,
                    alertShow: true,
                    resMessage: resDelete.data.errorSchema.errorMessage,
                    listMapel: this.state.listMapel.filter(sub => sub.idSubProfilCbt !== id)
                });
            }
        }      
        this.setState({isFetching: false })
    }
    confirmDialog() {
        const {hapusData, isHapusProfil, isHapusMapel} = this.state;
        const handleClose = () => { this.setState({isHapusProfil: false, isHapusMapel: false}) }; 
        let title, content, button;
        if(isHapusProfil) {
            title = "Hapus Profil ?"
            content = <DialogContentText id="alert-dialog-description">
                        Menghapus Profil juga akan menghapus Jadwal & report Siswa<br/>
                        Yakin akan menghapus Profil <strong>{hapusData.namaProfil}</strong> ?
                    </DialogContentText>
            button = <button className="btn btn-primary" onClick={() => this.delete(hapusData.idProfilCbt)} autoFocus> Ya </button>     
        } else {
            title = "Hapus Mata Pelajaran ?"
            content = <DialogContentText id="alert-dialog-description">
                        Yakin akan menghapus Mata Pelajaran <strong>{hapusData.namaMapel}</strong> ?
                    </DialogContentText>
            button = <button className="btn btn-success" onClick={() => this.deleteSub(hapusData.idSubProfilCbt)} autoFocus> Ya </button>          
        }       
        return (
            <>
            <Dialog
                open={isHapusProfil ? isHapusProfil : isHapusMapel}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    {content}
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-danger" onClick={handleClose}> Tidak </button>
                    {button}               
                </DialogActions>
            </Dialog>
            </>
        )
    } 
}
 
const mapStateToProps = (state) => {
    return{
        account: state.account        
    };
}
export default connect(mapStateToProps, {cekCookies})(AkmList);